import { Teaser as t } from '@xprog/prensa/types'

export const TeaserMostReadFixed: t.TeaserProps = {
  css: {
    align: ['row', 'center', 'middle'],
    borderBottom: '1px solid #E6E6E6',
    borderLeft: '8px solid $basicWhite',
    p: '$0',
    minHeight: '92px',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserNumber': {
      align: ['row', 'left', 'middle'],
      ml: '$4',
      mr: '$4',
      height: '100%',
      width: 'max-content'
    },
    '.TeaserNumberText': {
      color: '$primaryMain',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '20px',
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '$widget5',
      fontWeight: '$widget5',
      lineHeight: '$widget5'
    },
    '.TeaserWrap': {
      mr: '$4',
      width: 'calc(100% - $4)'
    },
    '&:last-child': {
      borderBottom: 'unset'
    },
    '&[data-selected=true]': {
      borderLeft: '8px solid $primaryMain'
    },
    '&[data-viewed=true]': {
      borderLeft: '8px solid #E7E7E7'
    }
  },
  className: 'TeaserNumber',
  numberVariant: 'default'
}